<template>
  <div class="failure">
    <div class="failure__top">
      <img
        src="../../static/images/no-credit.svg"
        alt="No Credit Alloted Image"
        class="failure__top__image"
      />
      <h3 class="failure__top__text">Unfortunately we cannot grant you credit at this point of time</h3>
    </div>
    <div class="failure__bottom">
      <p
        class="failure__bottom__text"
      >We really appreciate you taking out time to register with us. Unfortunately, we are unable to approve your application basis the data provided by you. This is probably due to a failure in one of the multiple checks that we do during account creation.</p>
      <p
        class="failure__bottom__text"
      >However, we review limits from time to time and would intimate you in case your limit is revised.</p>
    </div>
    <ActionButton @click="navigateToDashboard" title="Go to Dashboard" />
    <p
      class="failure__redirection-message"
    >You will be redirected to Customer Dashboard in {{timer}} seconds</p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "../components/ActionButton";

export default {
  name: "Signup-Failure",
  data() {
    return {
      timer: 30,
      timerInterval: undefined
    };
  },
  components: { ActionButton },
  computed: {},
  mounted() {
    this.$store.dispatch("signup_status");
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "SORRY"
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SIGNUP_COMPLETED",
      propertyName: "CREDIT_LIMIT",
      propertyValue: 0
    });
    this.timerInterval = setInterval(() => {
      if (this.timer > 0) {
        this.timer -= 1;
      } else {
        this.navigateToDashboard();
      }
    }, 1000);
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
  },
  methods: {
    navigateToDashboard() {
      window.clearInterval(this.timerInterval);
      if (this.$route.name === "Failure") {
        this.$store.dispatch("getUser").then(response => {
          response.version === "epaylaterv2"
            ? this.$router.push({ name: "Dashboard" })
            : this.$router.push({ name: "Home" });
          this.$store.commit("setLoginState", true);
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.failure {
  display: grid;
  grid-template-rows: auto 1fr auto;
  row-gap: 4rem;
  justify-items: center;
  &__top {
    margin: 0 -2rem;
    padding: 2rem;
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    background: var(--red);
    @media only screen and (min-width: 640px) {
      border-radius: 0.5rem;
      padding: 2.5rem 4rem;
      margin: unset;
    }
    &__image {
      margin-bottom: 1.6rem;
    }
    &__text {
      font-size: 2.2rem;
      text-align: center;
      color: var(--white);
      margin: 0;
    }
  }
  &__bottom {
    text-align: center;
    &__text {
      font-size: 1.6rem;
      color: var(--gray-2);
    }
  }
  &__redirection-message {
    color: var(--gray-2);
  }
}
.action-button {
  max-width: 27rem;
  &--no-underline {
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignupFailure.vue